var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "container-wrapper",
    {
      attrs: {
        designer: _vm.designer,
        widget: _vm.widget,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
      },
    },
    [
      _c(
        "el-row",
        {
          key: _vm.widget.id,
          staticClass: "grid-container",
          class: [_vm.selected ? "selected" : "", _vm.customClass],
          attrs: { gutter: Number(_vm.widget.options.gutter) },
          nativeOn: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.selectWidget(_vm.widget)
            },
          },
        },
        [
          _vm._l(_vm.widget.cols, function (colWidget, colIdx) {
            return [
              _c("grid-col-widget", {
                key: colWidget.id,
                attrs: {
                  widget: colWidget,
                  designer: _vm.designer,
                  "parent-list": _vm.widget.cols,
                  "index-of-parent-list": colIdx,
                  "parent-widget": _vm.widget,
                  "col-height": _vm.widget.options.colHeight,
                },
              }),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }